export default "__VITE_ASSET__DH_mc3V___"